"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const utils_1 = require("../../../utils");
const TitleSubtitleDiversity_1 = __importDefault(require("../../atoms/TitleSubtitleDiversity"));
const constants_1 = require("../../constants");
const DiversityOverlayProvider_1 = require("../../context/DiversityOverlayProvider");
const hooks_1 = require("../../hooks");
const OfflineWarningMessage_1 = __importDefault(require("../../molecules/OfflineWarningMessage"));
const subtitle = [
    (0, i18n_1.Localized)(i18n_1.Strings.diversity.thirdPage.subtitle),
];
function SkinToneSelectionPage() {
    const { state, dispatch } = (0, hooks_1.useDiversityOverlay)();
    const { isMobile } = (0, device_1.usePlatform)();
    const { selectedSkinTone, selectedPhenotype, selectedSex } = state;
    const image = `${selectedPhenotype}-${selectedSkinTone || '5'}`;
    const imageSrc = `${selectedSex}_head_${image}`;
    const convertColorToTone = (selectedTone) => { var _a; return (_a = constants_1.SKIN_TONES.find(({ color }) => color === selectedTone)) === null || _a === void 0 ? void 0 : _a.tone.toString(); };
    const convertToneToColor = (selectedTone) => { var _a; return (_a = constants_1.SKIN_TONES.find(({ tone }) => tone === +selectedTone)) === null || _a === void 0 ? void 0 : _a.color; };
    const onColorSelect = (color) => {
        const skinTone = convertColorToTone(color);
        dispatch((0, DiversityOverlayProvider_1.setSkinTone)(skinTone));
    };
    return ((0, jsx_runtime_1.jsxs)(ContentContainer, { "data-e2e": 'SkinToneSelectionPage_ContentContainer', children: [(0, jsx_runtime_1.jsx)(TitleSubtitleDiversity_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.diversity.thirdPage.title), subtitle: subtitle, "$isList": true, "data-e2e": 'SkinToneSelectionPage_TitleSubtitleDiversity' }), (0, jsx_runtime_1.jsx)(ui_1.ColorPicker, { colors: constants_1.SKIN_TONES.map(({ color }) => color), onSelect: onColorSelect, defaultColor: convertToneToColor(selectedSkinTone), "data-e2e": 'SkinToneSelectionPage_ColorPicker', children: (0, jsx_runtime_1.jsx)(ImageContainer, { "data-e2e": 'SkinToneSelectionPage_ImageContainer', children: (0, jsx_runtime_1.jsx)(Image, { src: (0, utils_1.getImage)(imageSrc), alt: image, "aria-label": imageSrc, tone: selectedSkinTone, "data-e2e": 'SkinToneSelectionPage_Image' }) }) }), (0, jsx_runtime_1.jsx)(OfflineWarningMessage_1.default, { isMobile: isMobile, "data-e2e": 'SkinToneSelectionPage_OfflineWarningMessage' })] }));
}
exports.default = SkinToneSelectionPage;
const ImageContainer = styled_components_1.default.div `
  position: absolute;

  top: 18px;
  left: 18px;

  width: 280px;
  height: 280px;

  margin: 0 auto;

  overflow: hidden;

  background: ${({ theme }) => theme.primary};

  border-radius: 50%;

  ${ui_1.deviceLandscape.mobileM((0, styled_components_1.css) `
    top: 20px;
    left: 17px;

    width: 234px;
    height: 234px;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    top: 24px;
    left: 24px;

    width: 396px;
    height: 396px;
  `)};
`;
const Image = styled_components_1.default.img `
  position: relative;
  top: 24px;
  left: 43px;

  width: 194px;
  height: 263px;

  ${({ tone }) => !tone &&
    (0, styled_components_1.css) `
      filter: grayscale(1);
    `}

  ${ui_1.deviceLandscape.mobileM((0, styled_components_1.css) `
    top: 15px;
    left: 35px;

    width: 164px;
    height: 220px;
  `)};

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    top: 25px;
    left: 60.5px;

    width: 275px;
    height: 373px;
  `)};
`;
const ContentContainer = styled_components_1.default.div `
  position: static;

  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;

  ${ui_1.devicePortrait.mobileS((0, styled_components_1.css) `
    flex-direction: column;
    height: 84vh;
    width: 100vw;
  `)}

  ${ui_1.deviceLandscape.laptopS((0, styled_components_1.css) `
    height: 92vh;
    flex-direction: column;
    overflow: hidden;
  `)}

  ${ui_1.deviceLandscape.laptop((0, styled_components_1.css) `
    height: 86vh;
  `)}

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    height: 70vh;
    margin-bottom: 140px;

    overflow: visible;
  `)}
`;
